<template>
  <section id="portfolio">
    <navigation :dark="true" class="absolute"></navigation>
    <div>
      <div v-for="item in portfolio"  class="portfolio-list"
           :style="{ 'background-image': 'url(/dist/' + item.backdrop + ')' }">
        <div class="description">
          <div class="wrapper">
            <h3>{{item.title}}</h3>
            <div class="scope">
              <h4 v-for="scope in item.scope">{{scope}}</h4>
            </div>
            <a class="button" :href="'/portfolio/' + item.id">Case Study</a>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import Navigation from '../components/navigation.vue';
  import Hero from '../components/hero.vue';
  require.context('../../assets/portfolio/', true);


  export default {
    components: {Navigation, Hero},
    props: {
      id: String,
      name: String,
    },

    data () {
      return {
        portfolio: require('../portfolio.json')
      }
    },

    mounted: function () {
      console.log(this.portfolio);
    }
  }
</script>

<style lang="scss">
  @import "../../css/main.scss";
  @import "../../css/portfolio.scss";
</style>


// WEBPACK FOOTER //
// portfolio.vue?7d228cb3